import { useQuery } from '@tanstack/react-query';
import { Trip } from './useTrips';

const API_BASE = process.env.REACT_APP_API_BASE || '';

export interface MyTrip extends Trip {
}

export function useMyTrips() {
  return useQuery({
    queryKey: ['my-trips'],
    queryFn: async () => {
      const response = await fetch(`${API_BASE}/api/users/me/trips`);
      if (!response.ok) throw new Error(`Server error: ${response.status}`);
      const body = await response.json() as { trips: MyTrip[] };
      return body.trips;
    },
  });
}
